import type { SVGProps } from 'react';

const SvgForge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 510 510"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M273.87 0V204.72C275.61 205.15 275.87 204 276.88 203.23C280.57 200.41 297.77 180.77 299.36 180.77L326.83 209.21L302.86 233.68H506.77V274.62H302.86L326.78 301.22L299.37 330.52L273.88 305.57V509.29H231.9V305.57L205.55 329.46L177.97 302.51L201.91 274.61H0V234.67L201.91 233.66L179.89 209.2L206.42 180.72L231.9 204.71V0H273.88H273.87Z"
      fill="currentColor"
    />
    <path
      d="M91.5995 63.98L193.829 167.41L167.889 195.28L165.899 195.35L64.4395 93.85L63.9395 92.37L91.5995 63.98Z"
      fill="currentColor"
    />
    <path
      d="M339.54 315.67L442.07 416.72C443.07 418.38 441.71 419.62 440.79 420.9C434.68 429.42 422.09 437.81 415.3 446.36L313.3 344.49L313.23 342.5L339.54 315.67Z"
      fill="currentColor"
    />
    <path
      d="M166.57 314.65L193.84 342.89L90.6002 445.31L62.9902 417.92L166.57 314.65Z"
      fill="currentColor"
    />
    <path
      d="M415.31 63.9302L442.78 92.3702L339.48 195.66L313.82 167.27L415.31 63.9302Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgForge;
